import React from 'react';
import FileUploader from '../../../../components/common/FileUploader';

const fileTableHeadComponent = <tr><th style={{width:"80px"}}></th><th>File name</th><th style={{width:"350px"}}>Description</th></tr>;
const fileTableRowCompponent=(file, index, deleteButton)=>{
    return <tr key={index}>
       <td>
          {deleteButton}
       </td>
       <td>
          <a target='_blank' href={process.env.REACT_APP_WEBAPI_URL + process.env.REACT_APP_FIELS_GET + "/" + file.id}>
             {file.fileOriginalName}
          </a>
       </td>
       <td>{file.description}</td>
 </tr>
 }
export default class ApprovalFormFileUploader  extends React.Component {

    fileUploaderDisplayListUpdate;
    fileUploaderFilesUploaded = (files) => {
        const form = this.props.approvalForm;
        const documents = form.val('documents');

        files.forEach(f=>{
            documents.push({
                id:f.id,
                description:f.description,
                fileName:f.fileName,
                fileType: f.fileType,
                fileUrl: f.fileUrl,
                fileSize: f.fileSize,
                fileOriginalName: f.fileOriginalName,
                fileGUID: f.fileGUID
            })
        });

        console.log(documents);
        form.vals({documents}, true, this.refresh);
    }

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        this.fileUploaderDisplayListUpdate(this.props.approvalForm.val('documents'));
    }

    onfileDeleted=(file)=>{
        const form = this.props.approvalForm;
        const documents = form.val('documents');
  
        for(var i = 0; i< documents.length; i++){
            if(file===documents[i]) {
                documents.splice(i, 1);
                break;
            }
        }
  
        form.vals({documents}, true, this.refresh);
     }

    render() {
        const form = this.props.approvalForm;
        return <FileUploader
            maxFileSizeMB={10}
            //allowFileTypes={["image/gif","image/jpe","image/jpg", "image/jpeg","image/png", "application/pdf", "application/vnd.openxmlformats","application/vnd.openxmlformats-officedocument.wordprocessingml.document"]}
            //fileTypeErrorMsg={"File type is not valid, please only uplaod pdf, word document or image files (jpeg, gif, png)"}
            exceedFileSizeErrorMsg = "Your file is too big"
            disabled={form.isFieldDisabled('documents') || form.isFormDisabled()}
            notShowInput={false}
            fileTableHeadComponent = {fileTableHeadComponent}
            fileTableRowCompponent = {fileTableRowCompponent}
            onFilesUploaded={this.fileUploaderFilesUploaded}
            provideDisplayDocumentsUpdator={(updateFunction)=>{this.fileUploaderDisplayListUpdate = updateFunction;}}
            onFileDeleted={this.onfileDeleted}
        />
    }
}